import { isGroupSetSchema, type GroupSetSchema, type GroupSchema, type SectionSchema } from '../types';
import type { Section } from '../models/Section';
import { useFormContext } from '../context/FormContext';
import { useGroupSet } from '../hooks/useGroupSet';
import { GroupView } from './GroupView';

export function GroupSet({
  groupSetSchema,
  section,
  sectionModel,
}: {
  groupSetSchema: GroupSetSchema;
  section: SectionSchema;
  sectionModel: Section;
}) {
  const groupSet = useGroupSet(groupSetSchema, sectionModel);

  const groupIndices = Array.from({ length: groupSet.count }, (_, i) => i);

  return (
    <div className="group-set">
      <div id={groupSetSchema.groupSetId}>
        {groupIndices.map((index) => (
          <GroupView
            key={`${groupSetSchema.group.id}-${index}`}
            groupSchema={groupSetSchema.group}
            section={sectionModel}
            index={index}
          />
        ))}

        <div>
          <hr className="pull-right" />

          <div className="stepform-question-wrapper">
            {groupSetSchema.label && (
              <div className="question table">
                <legend>{groupSetSchema.label}</legend>
              </div>
            )}

            {groupSetSchema.supportText && (
              <div
                className="qa-support-text"
                dangerouslySetInnerHTML={{ __html: groupSetSchema.supportText }}
              />
            )}

            <div className="answer-group">
              {groupSet.count < groupSet.max && (
                <button type="button" onClick={groupSet.add} className="button">
                  {groupSetSchema.labelAdd ?? 'Add'}
                </button>
              )}
              {groupSet.count > groupSet.min && (
                <button type="button" onClick={groupSet.remove} className="button">
                  {groupSetSchema.labelRemove ?? 'Remove'}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function SectionGroupRenderer({
  groupOrSet,
  section,
  sectionModel,
}: {
  groupOrSet: GroupSchema | GroupSetSchema;
  section: SectionSchema;
  sectionModel: Section;
}) {
  if (isGroupSetSchema(groupOrSet)) {
    return (
      <GroupSet groupSetSchema={groupOrSet} section={section} sectionModel={sectionModel} />
    );
  }

  return <GroupView groupSchema={groupOrSet} section={sectionModel} index={0} />;
}
